import React from 'react';
import PlaceholderPage from './PlaceholderPage';
import { Truck } from 'lucide-react';

export default function ShippingChargesPage() {
  return (
    <PlaceholderPage
      title="Shipping Charge Management"
      description="Configure shipping rates based on location and order value."
      icon={Truck}
    />
  );
}
